// @flow
import React, { PureComponent } from 'react';

import { ffrName } from 'utils/ffrNameUtils';
import type { StructureType } from 'types/Result';

type Props = {
  localStructure: StructureType,
  visiteurStructure: StructureType,
  pointLocal: number,
  pointVisiteur: number,
};

class RencontreClubs extends PureComponent<Props> {
  render() {
    const {
      localStructure: { nom: localNom, embleme: localEmbleme },
      visiteurStructure: { nom: visiteurNom, embleme: visiteurEmbleme },
      pointLocal,
      pointVisiteur,
    } = this.props;

    const localWin = pointVisiteur < pointLocal;
    const visitorWin = pointVisiteur > pointLocal;
    const classNameWin = 'ft-700';

    return (
      <>
        <div className="match__club">
          <p className={(localWin && classNameWin) || ''}>
            <span>{ffrName(localNom)}</span>
            <img src={localEmbleme} alt={`Logo ${ffrName(localNom)}`} width="24" height="24"/>
          </p>
        </div>
        <div className="match__info">
          <p className="match__score">
            <span className={(localWin && classNameWin) || ''}>{pointLocal}</span>
            <span className="match__colon">-</span>
            <span className={(visitorWin && classNameWin) || ''}>{pointVisiteur}</span>
          </p>
        </div>
        <div className="match__club">
          <p className={(visitorWin && classNameWin) || ''}>
            <img src={visiteurEmbleme} alt={`Logo ${ffrName(visiteurNom)}`} width="24" height="24"/>
            <span>{ffrName(visiteurNom)}</span>
          </p>
        </div>
      </>
    );
  }
}

export default RencontreClubs;
